import * as types from '../actions/actionTypes';

export const expandedTypeReducer = (state = "", action) => {
    var newState = { ...state }
    switch (action.type) {
        case types.SET_EXPANDED_TYPE:
            newState = action.payload
            return newState;
            break;
        default:
            return state;
    }
}
